/**
 * @generated SignedSource<<b46877157a52c270fddfe64fa255c9b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type SurveyStatus = "AVAILABLE" | "FAIL" | "PENDING" | "SUCCESS";
import { FragmentRefs } from "relay-runtime";
export type useSurveyListFragmentQuery_surveysRef$data = {
  readonly surveys: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly status: SurveyStatus;
        readonly tags: ReadonlyArray<string>;
        readonly url: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"useFinishedSurveyCardFragmentQuery_surveyRef" | "useSurveyCardFragmentQuery_surveyRef">;
      };
    }>;
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly " $fragmentType": "useSurveyListFragmentQuery_surveysRef";
};
export type useSurveyListFragmentQuery_surveysRef$key = {
  readonly " $data"?: useSurveyListFragmentQuery_surveysRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSurveyListFragmentQuery_surveysRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./SurveyListRefetchQuery.graphql')
    }
  },
  "name": "useSurveyListFragmentQuery_surveysRef",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "SurveyConnection",
      "kind": "LinkedField",
      "name": "surveys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SurveyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Survey",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tags",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useSurveyCardFragmentQuery_surveyRef"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useFinishedSurveyCardFragmentQuery_surveyRef"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserData",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "0b4b410f2d9c84a4d969964b00e56040";

export default node;
